import React from 'react';
import FaqContainer from "./FaqContainer";
import ContentContainer from "./ContentContainer";
import {Link} from "react-router-dom";
import logo from "../img/logo.png";
import gift from "../img/gift_no_patch.png";
import {withTranslation} from "react-i18next";
import FooterContainer from "./FooterContainer";

class PublicFaqPage extends React.Component {

    render() {
        return (
            <div>
                <div>
                    <nav className="navbar main-navbar">
                        <Link to="/" id="logo">
                            <img src={logo} alt="" className="logo-proximus"/>
                        </Link>
                        <div className="program-title">
                            <img src={gift} alt="" className="icon-gift"/>
                            {this.props.t('title')}
                        </div>
                    </nav>
                </div>
                <ContentContainer>
                    <FaqContainer></FaqContainer>
                </ContentContainer>
                <FooterContainer/>
            </div>)
    }

}

export default withTranslation()(PublicFaqPage);

